import styled, { keyframes } from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

const leftDuration = 1000
const rightDelay = leftDuration + 250
const rightDuration = 300
const rightInnerDuration = 500

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`

const expand = keyframes`
    from {
        flex-basis: 0px;
    }
    to {
        flex-basis: 600px;
    }
`

const slideIn = keyframes`
    from {
        opacity: 0;
        transform: translateX(300px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
`

const Base = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    overflow: hidden;
    flex-direction: column;
    width: 100%;

    ${breakpoint('laptop')`
        flex-direction: row;
        width: auto;
    `};
`

export const Container = Base

export const Left = styled(Base)`
    flex: 1;
    background-color: ${props => props.theme.admin.colors.brandDark};

    min-height: 120px;

    ${breakpoint('laptop')`
        min-height: 0;
    `};
`

export const LeftInner = styled(Base)`
    flex: 1;
    animation: ${fadeIn} ${leftDuration}ms ease-out both;

    .peracto-logo > svg {
        width: 200px;

        ${breakpoint('tablet')`
            width: 20rem;
        `};

        ${breakpoint('desktopL')`
            width: 30rem;
        `};
    }
`

export const Right = styled(Base)`
    flex: 0 0 0px;
    animation: ${expand} ${rightDuration}ms ease-out ${rightDelay}ms both;
`

export const RightInner = styled(Base)`
    flex: 1;
    position: relative;
    animation: ${slideIn} ${rightInnerDuration}ms ease-out both;
`

export const LoginFormContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background-color: #fff;

    display: flex;
    justify-content: center;
    align-items: center;

    &:before {
        content: none;
        position: absolute;
        top: -1vh;
        bottom: 0;
        left: -75px;
        width: 110px;
        background-color: ${props => props.theme.admin.colors.brandDark};
        transform: rotate(4deg);
        height: 101vh;

        ${breakpoint('laptop')`
            content: '';
        `};
    }

    > div {
        min-width: 270px;
        max-width: calc(100% - 30px);

        ${breakpoint('laptop')`
            min-width: 330px;
            max-width: 480px;
        `};
    }
`
